export default __webpack_public_path__ + "static/media/success-desktop.d403b126.svg";